export default __webpack_public_path__ + "static/media/committed.3f36f5c3.svg";